import React from 'react'

interface Properties {
    title: string
}

export default function SectionTitle({title}: Properties) {
    return (
        <h2 className="font-display font-semibold text-2xl text-neutral-800 pb-2 border-b-2 border-primary">
            {title}
        </h2>
    )
}
